"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var _date = require("../../utils/date");
var _userflow = require("../../constants/userflow");
var _Context = require("./Context");
var _SearcherFlexBadge = _interopRequireWildcard(require("../SearcherFlexBadge"));
var _PricewatchSubscribeBellIcon = _interopRequireDefault(require("./PricewatchSubscribeBellIcon"));
var _PricewatchSubscribeFormCancelButton = _interopRequireDefault(require("./PricewatchSubscribeFormCancelButton"));
var _SuccessIcon = _interopRequireDefault(require("../SuccessIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PricewatchSubscribeFormHeader = function PricewatchSubscribeFormHeader() {
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
    isMobile = _useContext.isMobile,
    state = _useContext.state,
    STATE = _useContext.STATE,
    viewParams = _useContext.viewParams,
    onCancel = _useContext.onCancel,
    isNotConfirmedUser = _useContext.isNotConfirmedUser,
    email = _useContext.email;
  var canBeCanceled = onCancel && state === STATE.EDIT;
  var countryRu = viewParams.countryRu,
    startDate = viewParams.startDate,
    nightCount = viewParams.nightCount,
    hasFlexDates = viewParams.hasFlexDates,
    hasFlexNights = viewParams.hasFlexNights;
  var shortDate = (0, _date.formatDate)(startDate, "dd".concat(_userflow.NBSP, "MMM"));
  var nights = [' ', nightCount, _userflow.NBSP, (0, _pluralizeUtils.pluralizeNights)(nightCount)].join('');
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  if (state === STATE.ERROR) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ErrorIcon, null), /*#__PURE__*/_react["default"].createElement(StyledTitle, null, t('subscribe.header.error.title')), /*#__PURE__*/_react["default"].createElement("div", null, t('subscribe.header.error.text')));
  }
  if (isNotConfirmedUser) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSuccessIcon, null), /*#__PURE__*/_react["default"].createElement(StyledTitle, {
      isMobile: isMobile
    }, t('subscribe.header.confirm.title')), /*#__PURE__*/_react["default"].createElement(SearchParamsWrapper, null, t('subscribe.header.confirm.wrapper', {
      email: "".concat(email)
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, canBeCanceled && /*#__PURE__*/_react["default"].createElement(Cancel, {
    onClick: onCancel
  }, t('subscribe.header.cancel')), (state === STATE.DEFAULT || state === STATE.EDIT) && /*#__PURE__*/_react["default"].createElement(BellIcon, {
    isMobile: isMobile,
    hasShadow: state === STATE.EDIT
  })), state === STATE.DONE && /*#__PURE__*/_react["default"].createElement(StyledSuccessIcon, null), /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, state === STATE.DONE ? t('subscribe.header.state.done') : "".concat(t('subscribe.header.state.title', {
    context: isMobile ? 'mobile' : 'desktop'
  }), " "), ' ', /*#__PURE__*/_react["default"].createElement(SearchParamsWrapper, null, countryRu, /*#__PURE__*/_react["default"].createElement("div", null, shortDate, hasFlexDates && /*#__PURE__*/_react["default"].createElement(FlexDates, {
    isMobile: isMobile,
    type: _SearcherFlexBadge.TYPES.BORDER
  }), ', ', nights, hasFlexNights && /*#__PURE__*/_react["default"].createElement(FlexDates, {
    isMobile: isMobile,
    type: _SearcherFlexBadge.TYPES.BORDER
  })))));
};
var Cancel = (0, _styledComponents["default"])(_PricewatchSubscribeFormCancelButton["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "PricewatchSubscribeFormHeader__Cancel",
  componentId: "sc-2tipe6-0"
})(["font-size:14px;position:absolute;top:16px;"]);
var FlexDates = (0, _styledComponents["default"])(_SearcherFlexBadge["default"]).withConfig({
  displayName: "PricewatchSubscribeFormHeader__FlexDates",
  componentId: "sc-2tipe6-1"
})(["margin-top:-2px;margin-left:4px;"]);
var SearchParamsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PricewatchSubscribeFormHeader__SearchParamsWrapper",
  componentId: "sc-2tipe6-2"
})(["font-weight:normal;color:#4d4d4d;display:inline;white-space:break-spaces;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "PricewatchSubscribeFormHeader__StyledTitle",
  componentId: "sc-2tipe6-3"
})(["font-size:16px;font-weight:bold;white-space:pre-line;margin-bottom:8px;", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && (0, _styledComponents.css)(["font-size:22px;"]);
});
var BellIcon = (0, _styledComponents["default"])(_PricewatchSubscribeBellIcon["default"]).withConfig({
  displayName: "PricewatchSubscribeFormHeader__BellIcon",
  componentId: "sc-2tipe6-4"
})(["position:absolute;top:-16px;left:8px;", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0, _styledComponents.css)(["position:absolute;top:10px;left:50%;transform:translateX(-50%);"]);
});
var StyledSuccessIcon = (0, _styledComponents["default"])(_SuccessIcon["default"]).withConfig({
  displayName: "PricewatchSubscribeFormHeader__StyledSuccessIcon",
  componentId: "sc-2tipe6-5"
})(["margin:7px 0;"]);
var ErrorIcon = (0, _styledComponents["default"])(_SuccessIcon["default"]).attrs({
  success: false
}).withConfig({
  displayName: "PricewatchSubscribeFormHeader__ErrorIcon",
  componentId: "sc-2tipe6-6"
})(["margin:7px 0;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeFormHeader);